import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

const StyledGatsbyImage = styled(GatsbyImage)``

const StyledImage = styled.img`
  ${StyledGatsbyImage}
`

const Image = (props) => {
  const { absolutePath, alt, className, image } = props
  const Element = image ? StyledGatsbyImage : StyledImage
  return (
    <Element
      alt={alt}
      className={className}
      image={image}
      src={absolutePath}
      loading="lazy"
    />
  )
}

Image.propTypes = {
  absolutePath: PropTypes.string,
  alt: PropTypes.string.isRequired,
  className: PropTypes.any,
  image: PropTypes.object,
}

export default Image
